import React from 'react';
import kilometer from '../../common/assets/images/kilometer.svg';
import rightMark from '../../common/assets/images/rightTick.svg';
import locationIcon from '../../common/assets/images/locationWithBase.svg';

const Inventory = () => {
  return (
    <div>
      <div className='bg-[#C1F0FB]'>
        <h2 className='container font-semibold text-3xl py-9'>
          More inventory from this dealer
        </h2>
      </div>
      <div className='container'>
        <div className='py-[50px] flex gap-[22px]'>
          <div
            className='bg-white border-[0.5px] border-[#575757] '
            style={{ boxShadow: '1px 1px 11px 2px #0000002B' }}
          >
            <div className="bg-[url('/src/common/assets/images/inventoryCar1.png')] bg-no-repeat min-w-[358px] min-h-[178px] py-[6px] px-[9px]">
              <div className='border w-full min-h-[165px]'></div>
            </div>
            <div className='py-[22px] px-[17px]'>
              <h6 className='font-medium text-xl pb-1'>$14,999</h6>
              <h6 className='font-medium text-xl text-[#00C4EF] pb-[6px]'>
                2014 Ford F-150 XLT SuperCab
              </h6>
              <div className='flex gap-2 pb-1'>
                <img src={kilometer} alt='' />
                <p className='text-lg'>73,080 miles</p>
              </div>
              <div className='flex gap-2 pb-1'>
                <img src={rightMark} alt='' />
                <p className='text-lg'>63 miles away</p>
              </div>
              <div className='flex gap-2'>
                <img src={locationIcon} alt='' />
                <p className='text-lg'>No accidents</p>
              </div>
            </div>
          </div>
          <div
            className='bg-white border-[0.5px] border-[#575757] '
            style={{ boxShadow: '1px 1px 11px 2px #0000002B' }}
          >
            <div className="bg-[url('/src/common/assets/images/inventoryCar2.png')] bg-no-repeat min-w-[358px] min-h-[178px] py-[6px] px-[9px]">
              <div className='border w-full min-h-[165px]'></div>
            </div>
            <div className='py-[22px] px-[17px]'>
              <h6 className='font-medium text-xl pb-1'>$14,999</h6>
              <h6 className='font-medium text-xl text-[#00C4EF] pb-[6px]'>
                2014 Ford F-150 XLT SuperCab
              </h6>
              <div className='flex gap-2 pb-1'>
                <img src={kilometer} alt='' />
                <p className='text-lg'>73,080 miles</p>
              </div>
              <div className='flex gap-2 pb-1'>
                <img src={rightMark} alt='' />
                <p className='text-lg'>63 miles away</p>
              </div>
              <div className='flex gap-2'>
                <img src={locationIcon} alt='' />
                <p className='text-lg'>No accidents</p>
              </div>
            </div>
          </div>
          <div
            className='bg-white border-[0.5px] border-[#575757]'
            style={{ boxShadow: '1px 1px 11px 2px #0000002B' }}
          >
            <div className="bg-[url('/src/common/assets/images/inventoryCar3.png')] bg-no-repeat min-w-[358px] min-h-[178px] py-[6px] px-[9px]">
              <div className='border w-full min-h-[165px]'></div>
            </div>
            <div className='py-[22px] px-[17px]'>
              <h6 className='font-medium text-xl pb-1'>$14,999</h6>
              <h6 className='font-medium text-xl text-[#00C4EF] pb-[6px]'>
                2014 Ford F-150 XLT SuperCab
              </h6>
              <div className='flex gap-2 pb-1'>
                <img src={kilometer} alt='' />
                <p className='text-lg'>73,080 miles</p>
              </div>
              <div className='flex gap-2 pb-1'>
                <img src={rightMark} alt='' />
                <p className='text-lg'>63 miles away</p>
              </div>
              <div className='flex gap-2'>
                <img src={locationIcon} alt='' />
                <p className='text-lg'>No accidents</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inventory;
